import { createFileRoute } from '@tanstack/react-router';
import { resolveSlugSeo, Seo } from '../-components/seo';
import { useLingui } from '@lingui/react/macro';
import { Layout } from './-components/layout';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { slugs } from './legal-disclaimer.meta';
import { wwwLocales } from './-components/utils';
import { trpc } from '@/lib/trpc';
import { useSuspenseQuery } from '@tanstack/react-query';
import { WwwPagePending } from './-components/page-pending';

export const Route = createFileRoute('/www/legal-disclaimer')({
	loader: ({ context }) => {
		context.queryClient.ensureQueryData(
			trpc.core.getLegalContent.queryOptions({ type: 'legal-disclaimer', locale: context.locale }),
		);
	},
	component: Component,
	pendingComponent: WwwPagePending,
});

function Component() {
	const { t } = useLingui();
	const { baseUrl, locale, hasLocalePrefix } = Route.useRouteContext();
	const { canonicalUrl, alternates } = resolveSlugSeo(hasLocalePrefix, baseUrl, locale, wwwLocales, slugs);
	const { data: html } = useSuspenseQuery(
		trpc.core.getLegalContent.queryOptions({ type: 'legal-disclaimer', locale: Route.useRouteContext().locale }),
	);

	return (
		<Layout>
			<Header />
			<Seo
				title={t`Legal Notice - Worldcoo`}
				description={t`Legal Notice regulating the use of the service of the website owned by WORLDCOO S.L.`}
				canonicalUrl={canonicalUrl}
				locale={locale}
				alternateLocales={[...wwwLocales]}
				alternates={alternates}
			/>

			<article className="unreset-tailwind mx-auto max-w-4xl p-8" dangerouslySetInnerHTML={{ __html: html }} />

			<Footer />
		</Layout>
	);
}
